export default __webpack_public_path__ + "static/media/plus-sign-for-brand-logos.0b1fd7d1.svg";